"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _helpers = require("../../helpers");

var _P = _interopRequireDefault(require("../typography/P"));

var _Link = _interopRequireDefault(require("../typography/Link"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Page = _styledComponents.default.li.withConfig({
  displayName: "Page",
  componentId: "dpbpzb-0"
})(["list-style:none;margin:0;padding:0;a{display:inline-block;padding:", ";background-image:none;&:hover,&:focus,&:active{text-decoration:underline;}font-size:1rem;font-weight:", ";line-height:1.5rem;@media ", "{font-size:0.875rem;line-height:1.25rem;}@media (max-width:370px){span{display:none;}}&[aria-disabled='true']{color:", ";text-decoration:none;pointer-events:none;}&[aria-current='true']{color:", ";font-weight:", ";}}"], (0, _helpers.getSpacing)('small'), (0, _helpers.fontWeight)('medium'), (0, _helpers.breakpoint)('maxMobile'), (0, _helpers.color)('statusDisabled'), (0, _helpers.color)('black'), (0, _helpers.fontWeight)('bold'));

var Pages = _styledComponents.default.ul.attrs({
  role: 'navigation',
  'aria-label': 'pagination'
}).withConfig({
  displayName: "Pages",
  componentId: "dpbpzb-1"
})(["display:flex;flex-direction:row;justify-content:center;list-style:none;margin:0;padding:0;"]);

var PageLink = function PageLink(_ref) {
  var children = _ref.children,
      to = _ref.to,
      Link = _ref.link,
      props = _objectWithoutProperties(_ref, ["children", "to", "link"]);

  return _react.default.createElement(Page, null, _react.default.createElement(Link, _extends({
    to: to
  }, props), children));
};

var Separator = (0, _styledComponents.default)(_P.default).withConfig({
  displayName: "Separator",
  componentId: "dpbpzb-2"
})(["padding:", " 0;"], (0, _helpers.getSpacing)('small'));

var getLimitedPages = function getLimitedPages(_ref2) {
  var page = _ref2.page,
      pages = _ref2.pages;
  // a negative number indicates a gap in the range and should be rendered as '…'
  if (pages <= 7) return _toConsumableArray(Array(pages)).map(function (e, i) {
    return i + 1;
  });
  if (page <= 4) return [].concat(_toConsumableArray(_toConsumableArray(Array(5)).map(function (e, i) {
    return i + 1;
  })), [-6, pages]);
  if (page + 4 > pages) return [1, -2].concat(_toConsumableArray(_toConsumableArray(Array(5)).map(function (e, i) {
    return i + pages - 4;
  })));
  return [1, -2, page - 2, page - 1, page, page + 1, page + 2, -pages + 1, pages];
};

var buildPaginationLink = function buildPaginationLink(location, queryKey) {
  return function (page) {
    var _location$split = location.split('?'),
        _location$split2 = _slicedToArray(_location$split, 2),
        path = _location$split2[0],
        query = _location$split2[1];

    var params = new URLSearchParams(query);
    params.set(queryKey, String(page));
    return "".concat(path, "?").concat(params.toString());
  };
};

var Pagination = function Pagination(_ref3) {
  var _ref3$page = _ref3.page,
      page = _ref3$page === void 0 ? 1 : _ref3$page,
      _ref3$pages = _ref3.pages,
      pages = _ref3$pages === void 0 ? 1 : _ref3$pages,
      _ref3$link = _ref3.link,
      link = _ref3$link === void 0 ? _Link.default : _ref3$link,
      _ref3$location = _ref3.location,
      location = _ref3$location === void 0 ? '?' : _ref3$location,
      _ref3$queryKey = _ref3.queryKey,
      queryKey = _ref3$queryKey === void 0 ? 'page' : _ref3$queryKey;
  var getLinkForPage = buildPaginationLink(location, queryKey);
  return _react.default.createElement(Pages, null, _react.default.createElement(PageLink, {
    "aria-disabled": page === 1,
    to: getLinkForPage(Math.max(1, page - 1)),
    link: link
  }, "\u2190 ", _react.default.createElement("span", null, "Prev")), getLimitedPages({
    page: page,
    pages: pages
  }).map(function (i) {
    return i > 0 ? _react.default.createElement(PageLink, {
      key: i,
      "aria-current": page === i,
      "aria-disabled": page === i,
      to: getLinkForPage(i),
      link: link
    }, i) : _react.default.createElement(Separator, {
      key: i
    }, "\u2026");
  }), _react.default.createElement(PageLink, {
    "aria-disabled": page === pages,
    to: getLinkForPage(Math.min(pages, page + 1)),
    link: link
  }, _react.default.createElement("span", null, "Next"), " \u2192"));
};

var _default = Pagination;
exports.default = _default;